'use client';

import * as React from 'react';

import { cn } from '@workspace/ui/lib/utils';

export type SymbolElement = React.ComponentRef<'div'>;
export type SymbolProps = React.ComponentPropsWithoutRef<'div'> & {
  hideSymbol?: boolean;
};
export function Symbol({
  hideSymbol,
  className
}: SymbolProps): React.JSX.Element {
  return (
    <div className={cn(className)}>
      {!hideSymbol && (
        <div className="flex size-9 items-center justify-center p-1">
          <div className="flex size-7 items-center justify-center rounded-full text-primary-foreground bg-primary">
            S
          </div>
        </div>
      )}
    </div>
  );
}
